import '../styles/globals.scss';

import styles from './index.module.scss';

import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';

import Footer from './Footer';
import Header from './Header';
import ImgLogoSocial from '!!file!src/images/img-logo-social.png';

const TemplateWrapper = ({ children }) => (
  <div style={{overflowX: 'hidden'}}>
      <Helmet
          title='Galleon Logistics'
          meta={[
            {
              name: 'description',
              content: 'Galleon Logistics: Shipping optimization for the 21st century.'
            },
            {
              name: 'keywords',
              content: 'galleon, galleon logsitics, parcel audit, parcel analytics'
            },
            {
              property: 'og:type',
              content: 'website'
            },
            {
              property: 'og:description',
              content: 'Galleon Logistics: Shipping optimization for the 21st century'
            },
            {
              property: 'og:image',
              content: ImgLogoSocial
            }
          ]}
      />
      <Header />
      {children()}
      <Footer />
  </div>
);

TemplateWrapper.propTypes = {
  children: PropTypes.func
};

export default TemplateWrapper;



// WEBPACK FOOTER //
// ./src/layouts/index.js